<template>
  <div class="custom-centered-modal" v-if="installmentRec" @keydown.esc.stop.prevent="closeModal"  tabindex="0">
  <div class="custom-centered-modal">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="closeModal">&times;</button>
          <h4 class="modal-title text-center">سداد قسط</h4>
        </div>

        <div class="modal-body">
          <div class='col-lg-4' style='padding:5px;'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>القســــط:</span>
              <input disabled :value='installmentRec.amount' class='form-control' name='presenter' type='text'>
            </div>
          </div>
          <div class='col-lg-4' style='padding:5px;'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>المســــدد:</span>
              <input disabled :value='installmentRec.paid' class='form-control' name='presenter' type='text'>
            </div>
          </div>
          <div class='col-lg-4' style='padding:5px;'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>المطلوب:</span>
              <input disabled :value='Number(installmentRec.amount) - Number(installmentRec.paid)' class='form-control' name='presenter' type='text'>
            </div>
          </div>
          <div class='col-lg-4' style='padding:5px;'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>المدفوع:</span>
              <input ref="payInput" @keypress="isNumber($event)" v-on:input="remainingAmount()" v-model='installmentRec.pay' class='form-control' name='presenter' type='text' autocomplete="off"  autocorrect="off" autocapitalize="off" spellcheck="false" onpaste="return false" oncopy="return false" oncut="return false" oncontextmenu="return false">
            </div>
          </div>
          <div class='col-lg-4' style='padding:5px;'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>التاريـــــــخ:</span>
              <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='installmentRec.payment_date'></Datepicker>
            </div>
          </div>
          <div class='col-lg-4' style='padding:5px;'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>البــاقـــى:</span>
              <input disabled :value='installmentRec.Remaining' :style="{ color: installmentRec.Remaining < 0 ? 'red' : '' }" class='form-control' name='presenter' type='text'>
            </div>
          </div>
          <div class='col-lg-6' style='padding:5px;'>
          <div class="form-group input-group" style='margin: 0px'>
            <span class="input-group-addon" style='padding:5px;'>المحصــل:</span>
            <select class="form-control" style="padding: 0px" v-model="installmentRec.collector_id">
              <option
              v-for="u in technicals"
              :key="u.id"
              :value="u.id"
              >
              {{ u.name }} : {{u.id}}
            </option>
          </select>
        </div>
      </div>
      <div class='col-lg-6' style='padding:5px;'>
      <div class="form-group input-group" style='margin: 0px'>
        <span class="input-group-addon" style='padding:5px;'>الخزنة:</span>
        <select class="form-control" style="padding: 0px" v-model="installmentRec.treasury_id">
          <option
          v-for="u in treasuries"
          :key="u.id"
          :value="u.id"
          >
          {{ u.name }}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-sm-12" style="padding:5px 5px 10px 5px">
      <div v-if="installmentRec.type === 4" class="col-lg-4">
        <button v-show="$per.value.saveInstallmentPaymrnt" @click='startNewPartialPayment()'  type='button' class='btn btn-primary btn-block btn-outline btn-sm'>جديد</button>
      </div>
      <div class="col-lg-4">
      <button v-show="($per.value.saveInstallmentPaymrnt && installmentRec.id === 0 ) || ($per.value.editInstallmentPaymrnt)" @click='saveData()'  type='button' class='btn btn-outline btn-block btn-sm btn-success'>حفظ</button>
      </div>
      <div v-if="installmentRec.type > 1" class="col-lg-4">
        <button v-show="$per.value.emptyInstallmentPaymrnt" @click='deleteInstallment(1, installmentRec.id)' type='button' class='btn btn-outline btn-block btn-danger btn-sm'>حذف عمليات سداد القسط</button>
      </div>
    </div>
  </div>
  <div v-if="installmentRec.sub_payments.length > 0" class="row">
    <div  class="col-lg-12 col-sm-12">
      <div class="panel panel-default">
        <div class="panel-heading" style="height: 25px;padding: 2px 2px 0px 0px;text-align:center;">
             أقساط مجزئة
        </div>
      <table width='100%' class='table  table-bordered ' >
            <thead>
              <tr>
                <th style='width:5%;padding:2px;text-align: center'>م</th>
                <th style='width:15%;padding:2px;text-align: center'>المدفوع</th>
                <th style='width:35%;padding:2px;text-align: center'>ت. السداد</th>
                <th style='width:45%;padding:2px;text-align: center'>المحصل</th>
                <th style='width:45%;padding:2px;text-align: center'>المحصل</th>
              </tr>
            </thead>
            <tbody>
              <tr :class="{highlight :selectedSubrec == subRecord.id}" v-for='(subRecord,index) in installmentRec.sub_payments' :key='subRecord.id'  v-on:click="fillSubRec(subRecord)">
                <td style='width:5%;padding:2px;text-align: center'>{{index+1}}</td>
                <td style='width:15%;padding:2px;text-align: center'>{{subRecord.payed}}</td>
                <td style='width:35%;padding:2px;text-align: center'>{{subRecord.payment_date}}</td>
                <td style='width:45%;padding:2px;text-align: center'>{{subRecord.collector_name}}</td>
                <td style='width:45%;padding:2px;text-align: center'><i class="fa fa-trash-o" style="color: red;" @click="deleteInstallment(0, subRecord.id)"></i></td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>

        </div>

        <div class="modal-footer">
          <button type='button'
                  class='btn btn-outline btn-sm btn-default'
                  @click="closeModal">
            إغلاق
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import API from '@/store/api'
import Swal from 'sweetalert2'
import moment from 'moment'
export default {
  name: 'InstallmentPayModal',
  // *********************************************
  components: { Datepicker },
  // *********************************************
  props: {
    installment: {
      type: Object,
      required: true
    },
    treasuries: {
      type: Array,
      required: true
    },
    technicals: {
      type: Array,
      required: true
    },
    ar: Object,
    customFormatter: Function
  },
  // *********************************************
  data () {
    return {
      installmentRec: null,
      rerurnedRecords: [],
      selectedSubrec: null
    }
  },
  // *********************************************
  created () {
    const installmentRec = JSON.parse(JSON.stringify(this.installment))
    if ((Number(installmentRec.paid) || 0) === 0) {
      installmentRec.type = 1 // قسط كامل جديد
    } else {
      if ((Number(installmentRec.paid) || 0) === (Number(installmentRec.amount) || 0)) {
        installmentRec.pay = installmentRec.paid
        installmentRec.paid = 0
        installmentRec.type = 2 // تتعديل قسط كامل
      } else {
        installmentRec.type = 3 // قسط جزئى جديد
      }
    }
    this.installmentRec = installmentRec
    this.remainingAmount()
    this.focusPayInput()
  },
  // *********************************************
  methods: {
    focusPayInput () {
      this.$nextTick(() => {
        if (this.$refs.payInput) {
          this.$refs.payInput.focus()
          this.$refs.payInput.select()
        }
      })
    },
    // ==================================================
    onInstallmentModalClose (result) {
      this.showInstallmentPayModal = false
    },
    // ==================================================
    closeModal () {
      this.$emit('return-data', this.rerurnedRecords.balance, this.rerurnedRecords.customerId)
      this.$emit('close', {
        rerurnedRecords: this.rerurnedRecords
      })
    },
    // ==================================================
    remainingAmount () {
      this.installmentRec.Remaining =
        Number(this.installmentRec.amount || 0) - Number(this.installmentRec.paid || 0) - Number(this.installmentRec.pay || 0)
    },
    // ==================================================
    isNumber (evt) {
      const c = evt.which ? evt.which : evt.keyCode
      if ((c > 31 && (c < 48 || c > 57)) && c !== 46) {
        evt.preventDefault()
      }
    },
    // ==================================================
    fillSubRec (recID) {
      var record = {}
      const totalPaid = Number(
        recID.total_paid !== undefined && recID.total_paid !== null
          ? recID.total_paid
          : 0
      )

      const currentPay = Number(
        recID.payed !== undefined && recID.payed !== null
          ? recID.payed
          : 0
      )
      this.selectedSubrec = recID.id
      this.installmentRec = {}
      record.amount = recID.amount
      record.collector_id = recID.collector_id
      record.due_date = recID.due_date
      record.sub_id = recID.id
      record.id = recID.main_id
      record.pay = currentPay
      record.paid = totalPaid - currentPay
      record.payment_date = recID.payment_date
      record.treasury_id = recID.treasury_id
      record.reference_id = this.installment.reference_id
      record.reference_type = this.installment.reference_type
      record.sub_payments = this.installment.sub_payments
      record.type = 4 // تعديل قسط جزئى
      this.installmentRec = record
      this.remainingAmount()
      this.focusPayInput()
    },
    // ==================================================
    startNewPartialPayment () {
      if (this.installmentRec.hasOwnProperty('sub_id')) {
        this.$delete(this.installmentRec, 'sub_id')
      }
      var totalPaid = 0
      var i = 0
      for (i in this.installmentRec.sub_payments) { totalPaid += this.installmentRec.sub_payments[i].payed }
      this.installmentRec.treasury_id = null
      this.installmentRec.collector_id = null
      this.installmentRec.pay = null
      this.installmentRec.paid = totalPaid
      this.installmentRec.payment_date = null
      this.remainingAmount()
      this.focusPayInput()
    },
    // ==================================================
    async saveData () {
      var validationErrors = []
      var isError = false
      // ------------------------------------------------
      if (this.installmentRec.pay < 1) {
        validationErrors.push('يجب إدخال المبلغ المدفوع')
        isError = true
      }
      // -------------------------------
      if (!Number.isInteger(this.installmentRec.Remaining) || this.installmentRec.Remaining < 0) {
        validationErrors.push('المبلغ المدفوع أكبر من المبلغ المطلوب')
        isError = true
      }
      // -------------------------------
      if (!moment(this.installmentRec.payment_date, 'YYYY-MM-DD', true).isValid()) {
        validationErrors.push('يجب ادخال تاريخ السداد')
        isError = true
      }
      // ------------------------------------------------
      if (!Number.isInteger(this.installmentRec.collector_id) || this.installmentRec.collector_id < 1) {
        validationErrors.push('يجب اختيار المحصل')
        isError = true
      }
      // ------------------------------------------------
      if (!Number.isInteger(this.installmentRec.treasury_id) || this.installmentRec.treasury_id < 1) {
        validationErrors.push('يجب اختيار الخزنة')
        isError = true
      }
      if (isError === true) {
        Swal.fire({
          icon: 'error',
          title: 'يوجد أخطاء',
          html: `
            <ul style="text-align:right; direction:rtl; padding-right:20px;">
              ${validationErrors.map(err => `<li>${err}</li>`).join('')}
            </ul>
          `,
          confirmButtonText: 'حسناً'
        })
        return
      }
      // ------------------------------------------------
      this.installmentRec.payment_date = moment(this.installmentRec.payment_date).format('YYYY-MM-DD')
      const result = await Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حفظ العمليه مباشرة فى قاعدة البيانات',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
      if (result.isConfirmed) {
        try {
          const data = await API.installmentPayment(
            this.installmentRec
          )
          this.rerurnedRecords = data
          this.closeModal()
          Swal.fire({
            position: 'fixed',
            icon: 'success',
            title: 'تم الحفظ بنجاح',
            showConfirmButton: false,
            timer: 1000
          })
        } catch (err) {
          this.validationErrors = err.errors
        }
      }
    },
    // ==================================================================
    async deleteInstallment (type, id) {
      const result = await Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف السداد مباشرة من قاعدة البيانات',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
      if (result.isConfirmed) {
        try {
          const data = await API.installmentPaymentDelete(
            {
              type: type,
              id: id,
              reference_id: this.installment.reference_id,
              reference_type: this.installment.reference_type
            }
          )
          this.rerurnedRecords = data
          this.closeModal()
          Swal.fire({
            position: 'fixed',
            icon: 'success',
            title: 'تم الحفظ بنجاح',
            showConfirmButton: false,
            timer: 1000
          })
        } catch (err) {
          this.validationErrors = err.errors
        }
      }
    }
    // ==================================================================
  }
}
</script>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Sales/Customers/contractModale/InstallmentPayModal.vue